import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TAccessManagementStore,
	TEmKeycloakUsersResponsePayload,
	TKeycloakGroupsResponsePayload,
	TKeycloakUsersResponsePayload,
} from './types';

export const getAccessManagementState = (state: TStoreState): TAccessManagementStore =>
	state.accessManagement;

export const getEmKeycloakUsers = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.emKeycloakUsers,
);

export const getEmKeycloakUsersData = createSelector(
	[getEmKeycloakUsers],
	(data: TEmKeycloakUsersResponsePayload) => data,
);

export const getEmKeycloakUsersLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.emKeycloakUsersLoading,
);

export const getEmKeycloakUsersFailure = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.emKeycloakUsersFailure,
);

export const getKeycloakGroups = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.keycloakGroups,
);

export const getKeycloakGroupsData = createSelector(
	[getKeycloakGroups],
	(data: TKeycloakGroupsResponsePayload) => data,
);

export const getKeycloakGroupsLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.keycloakGroupsLoading,
);

export const getKeycloakUsers = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.keycloakUsers,
);

export const getKeycloakUsersData = createSelector(
	[getKeycloakUsers],
	(data: TKeycloakUsersResponsePayload) => data,
);

export const getKeycloakUsersLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.keycloakUsersLoading,
);

// actions state
export const getAttachEmUserLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.attachEmUserLoading,
);
export const getAttachEmUserSuccess = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.attachEmUserSuccess,
);

export const getDetachEmUserLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.detachEmUserLoading,
);
export const getDetachEmUserSuccess = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.detachEmUserSuccess,
);

export const getCreateEmUserLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.createEmUserLoading,
);
export const getCreateEmUserSuccess = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.createEmUserSuccess,
);

export const getSetUserEnabledLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.setUserEnabledLoading,
);
export const getSetUserEnabledSuccess = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.setUserEnabledSuccess,
);

export const getResetUserPasswordLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.resetUserPasswordLoading,
);
export const getResetUserPasswordSuccess = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.resetUserPasswordSuccess,
);

// connected emerchants
export const selectConnectedEmerchants = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.connectedEmerchants,
);

export const selectConnectedEmerchantsLoading = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.connectedEmerchantsLoading,
);

export const selectConnectedEmerchantsFailure = createSelector(
	[getAccessManagementState],
	(state: TAccessManagementStore) => state.connectedEmerchantsFailure,
);
